<template>
	<modal @close="closeModal" v-if="isModalVisible">
		<template slot="header">
			<h4 class="modal-title">Edit Seo</h4>
		</template>
		<template slot="body">
			<div class="flex box">
				<div class="card seven">
					<header class="card-header language-list">
						<lang-selector></lang-selector>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="group">Select group:</label>
							<select id="group" v-model="selectedSeo.scope">
								<option v-for="group in metaConfig.groups" :value="group">{{ group }}</option>
							</select>
						</div>
						<div class="form-group">
							<label for="key">Key:</label>
							<select id="key" required v-model="selectedSeo.key">
								<option disabled selected value="Select Meta Tag">Select Meta Tag</option>
								<optgroup :label="metaGroupIndex" v-for="( metaGroupName, metaGroupIndex ) in metaConfig.tags">
									<option v-for="( metaName, metaIndex ) in metaConfig.tags[metaGroupIndex]" :value="metaGroupIndex + '.' + metaIndex">{{ metaGroupIndex + '.' + metaIndex }}</option>
								</optgroup>
							</select>
							<p class="input-error" v-if="errors.errors['key']">{{ errors.errors['key'] }}</p>
						</div>
						<div class="form-group">
							<label for="content">Content:</label>
							<textarea @keyup="updatePreview" id="content" v-model="selectedSeo.translations[clickedLang].content"></textarea>
							<p class="input-error" v-if="errors.errors[errorModalContent]">{{ errors.errors[errorModalContent] }}</p>
						</div>
						<div class="form-group" :key="state">
							<label for="preview">Preview:</label>
							<textarea id="preview" disabled v-model="selectedSeo.preview[clickedLang].content"></textarea>
						</div>
					</div>
				</div>
				<div class="card five">
					<header class="card-header">
						<h4 class="card-title">Help</h4>
					</header>
					<div class="card-body">
						<h5 class="card-subtitle">How to use</h5>
						<p v-if="selectedSeo.key">{{ metaConfig.tags[selectedSeo.key.split('.')[0]][selectedSeo.key.split('.')[1]].description }}</p>

						<h5 class="card-subtitle">Available variables</h5>
						<ul class="list" v-if="selectedSeo.scope">
							<li v-for="(item, key) in metaConfig[selectedSeo.scope + '_variables']">{{ key }} - {{ item }}</li>
						</ul>
					</div>
				</div>
			</div>
		</template>
		<template slot="footer">
			<a @click="closeModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
			<a @click="saveSeo" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
		</template>
	</modal>
</template>

<script>
import Errors from "../../Utils/Errors";
import modal from '../Modal/DefaultModal.vue';
import {eventBus} from "../../app";

export default {
	components: {modal},
	name: "SeoEditor",
	props: {
		metaConfig: {
			required: true
		}
	},
	data() {
		return {
			isModalVisible: false,
			clickedLang: this.$defaultLanguage.locale,
			defaultLocale: this.$defaultLanguage.locale,
			selectedSeo: {
				scope: null,
				key: null,
				translations: {},
				preview: {}
			},
			originalSeo: null,
			state: 0,
			errors: new Errors()
		}
	},
	created() {
		let vm = this;

		// When setActiveStatus method ran, change article data in form fields
		/* From LangSelectorCommercialModal */
		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;
		});

		for (let i = 0; i < vm.$availableLanguages.length; i++) {
			vm.selectedSeo.translations[vm.$availableLanguages[i].locale] = {};
			vm.selectedSeo.translations[vm.$availableLanguages[i].locale]['content'] = '';

			vm.selectedSeo.preview[vm.$availableLanguages[i].locale] = {
				'content': ''
			};
		}

		eventBus.$on('onSeoModalOpen', function (seo) {
			if (seo) {
				vm.originalSeo = seo;
				vm.selectedSeo = _.cloneDeep(seo);

				let previews = {};
				let translations = {};
				for (let i = 0; i < vm.$availableLanguages.length; i++) {
					if (!vm.selectedSeo.translations.hasOwnProperty(vm.$availableLanguages[i].locale)) {
						translations[vm.$availableLanguages[i].locale] = {};
						translations[vm.$availableLanguages[i].locale]['content'] = '';
					} else {
						translations[vm.$availableLanguages[i].locale] = vm.selectedSeo.translations[vm.$availableLanguages[i].locale];
					}

					previews[vm.$availableLanguages[i].locale] = {
						'content': ''
					};
				}
				vm.selectedSeo.translations = translations;
				let tag = vm.metaConfig.tags[vm.selectedSeo.key.split('.')[0]][vm.selectedSeo.key.split('.')[1]];
				for (let i = 0; i < vm.$availableLanguages.length; i++) {
					if (vm.selectedSeo.translations.hasOwnProperty(vm.$availableLanguages[i].locale)) {
						previews[vm.$availableLanguages[i].locale]['content'] = tag.pattern.replace('#content#', vm.selectedSeo.translations[vm.$availableLanguages[i].locale]['content']);
					}
				}

				vm.selectedSeo.preview = previews;
			}
			vm.isModalVisible = true;
		});
	},
	methods: {
		closeModal: function () {
			this.isModalVisible = false;
			this.clickedLang = this.$defaultLanguage.locale;
			this.errors.clear();
			if (this.originalSeo) {
				this.originalSeo.preview = this.selectedSeo.preview[this.$defaultLanguage.locale].content;
			}
			this.selectedSeo = {
				scope: null,
				key: null,
				translations: {},
				preview: {}
			};
			for (let i = 0; i < this.$availableLanguages.length; i++) {
				this.selectedSeo.translations[this.$availableLanguages[i].locale] = {
					'content': ''
				};
				this.selectedSeo.preview[this.$availableLanguages[i].locale] = {
					'content': ''
				};
			}
		},
		updatePreview: function () {
			let vm = this;
			let tag = vm.metaConfig.tags[vm.selectedSeo.key.split('.')[0]][vm.selectedSeo.key.split('.')[1]];
			for (let i = 0; i < vm.$availableLanguages.length; i++) {
				if (vm.selectedSeo.translations.hasOwnProperty(vm.$availableLanguages[i].locale)) {
					vm.selectedSeo.preview[vm.$availableLanguages[i].locale]['content'] = tag.pattern.replace('#content#', vm.selectedSeo.translations[vm.$availableLanguages[i].locale]['content']);
				}
			}
		},
		saveSeo: function (callback) {
			let vm = this;
			let originData = _.cloneDeep(vm.selectedSeo);
			for (let i = 0; i < this.$availableLanguages.length; i++) {
				if (this.$availableLanguages[i].locale !== this.$defaultLanguage.locale &&
						originData['translations'][this.$availableLanguages[i].locale] &&
						(originData['translations'][this.$availableLanguages[i].locale].content === '' || originData['translations'][this.$availableLanguages[i].locale].content === null)) {
					delete (originData['translations'][this.$availableLanguages[i].locale]);
				}
			}
			if (vm.selectedSeo.hasOwnProperty('id')) {
				axios.put('/api/' + vm.$selectedSite.slug + '/seos/' + vm.selectedSeo.id, originData)
						.then(function (response) {
							if (response.data) {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.success('Seo saved.', 'Success');
								window.location.reload()
							}
						})
						.catch(function (e) {
							eventBus.$emit('onLoaderFinish');
							vm.errors.record(e.response.data);
							vm.$toastr.error('Seo save failed.', 'Error');
						});
			} else {
				axios.post('/api/' + vm.$selectedSite.slug + '/seos/create', originData)
						.then(function (response) {
							if (response.data) {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.success('Seo saved.', 'Success');
								window.location.reload()
							}
						})
						.catch(function (e) {
							eventBus.$emit('onLoaderFinish');
							vm.errors.record(e.response.data);
							vm.$toastr.error('Seo save failed.', 'Error');
						});
			}
		}
	},
	computed: {
		errorModalContent: function () {
			return 'translations_' + this.clickedLang + '_content';
		},
	}
}
</script>

<style scoped>

</style>
